/* eslint-disable */
import qs from 'qs';
import cx from 'classnames';
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken, getParams, money } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import OzTabs from '../lib/OzTabs';
import Wrapper from './Wrapper';
import OzPills from './partials/OzPills';
import ProRoomForm from './partials/ProRoomForm';
import ScheduleForm from './partials/ScheduleForm';
import WeeklySlotForm from './partials/WeeklySlotForm';
import OzModalButton from './partials/OzModalButton';
import ProBookableSlots from './partials/ProBookableSlots';
import SimpleEscapeForm from './partials/SimpleEscapeForm';
import LeaderboardWidget from './partials/LeaderboardWidget';

import './ProManageRoom.css';
import {
  fetchUser,
  listCompanies,
  getRoom,
  updateRoom,
  createSchedule,
  updateSchedule,
  deleteSchedule,
  listSchedules,
  createWeeklySlot,
  deleteWeeklySlot,
  listEscapes,
  updateEscape,
  addEscape,
} from '../actions';


class EditLeaderboard extends Component {

  state = {};

  componentDidMount() {
    this.props.listEscapes({ room: this.props.roomId }, { local: true, silent: true })
      .then(resp => {
        this.setState({ escapes: resp.items });
      });
  }

  didUpdate() {
    return this.props.listEscapes({ room: this.props.roomId }, { local: true })
      .then(resp => {
        this.setState({ escapes: resp.items, editing: null });
      });
  }

  saveEscape(e, escapeId, values) {
    this.props.updateEscape(escapeId, values.escape)
      .then(resp => {
        if (resp.error) return;
        this.didUpdate();
      });
  }

  verify(escapeId) {
    this.props.updateEscape(escapeId, { verified: true })
      .then(resp => this.didUpdate());
  }

  unverify(escapeId) {
    this.props.updateEscape(escapeId, { verified: false })
      .then(resp => this.didUpdate());
  }

  renderEscapes() {
    let escapes = this.state.escapes;
    if (!escapes) return;
    console.log('widget escapes', escapes);

    if (escapes.length == 0) {
      return (
        <div className="no-escapes">
          <div className="no-escapes-header">No escapes yet</div>
          <p>To get started, add some escapes to your leaderboard.</p>
          <p>You'll be able to edit and change them later.</p>
        </div>
      );
    }

    escapes.sort((a, b) => {
      let apt = a.prettyTime || '9999:99';
      let bpt = b.prettyTime || '9999:99';
      return apt.localeCompare(bpt);
    });

    let rank = 1;
    let nodes = escapes.map(escape => {
      let r = '';
      if (escape.verified) {
        r = '#' + rank;
        rank++;
      }
      return (
        <div className="escape" key={escape.id}>
          <div className="rank">{r}</div>
          <div className="name">{escape.displayName}</div>
          <div className="time">{escape.didEscape ? escape.prettyTime : 'Did not escape'}</div>
          <div className="controls">
            <OzModalButton
              modalTitle="Edit Escape"
              show={this.state.editing == escape.id}
              onShow={() => this.setState({ editing: escape.id })}
              onHide={() => this.setState({ editing: null })}
              >
              <Button bsSize="small">Edit</Button>

              <SimpleEscapeForm
                values={escape}
                modal={true}
                errors={this.props.errors.addEscape}
                buttonText="Save"
                cancelText="Cancel"
                onSubmit={(e, values) => this.saveEscape(e, escape.id, values)}
                onCancel={() => this.setState({ editing: null })}
              />
            </OzModalButton>{' '}

            <Link to={'/e/' + escape.room.slug + '/' + escape.id}>
              <Button bsSize="small">View</Button>
            </Link>

            {escape.verified && <Button bsSize="small" onClick={() => this.unverify(escape.id)}>Hide</Button>}
            {!escape.verified && <Button bsSize="small" bsStyle="primary" onClick={() => this.verify(escape.id)}><FontAwesome name="check-circle" /> Show</Button>}
          </div>
        </div>
      );
    });

    return (
      <div className="leaderboard">
        <div className="escapes">
          {nodes}
        </div>
      </div>
    );
  }

  addEscape(e, values) {
    console.log('add escape', values);
    this.props.addEscape(values)
      .then(resp => {
        if (resp.error) return;
        this.didUpdate().then(() => this.setState({ adding: false }));
        if (this.props.onAdd) {
          this.props.onAdd();
        }
      });
  }

  render() {
    let room = this.props.room;

    return (
      <div className="EditLeaderboard">
        <div className="header">
          <div className="title">
            Manage <b>{room.name}</b> leaderboard
          </div>

          <div className="controls">
            <OzModalButton
              modalTitle="Add Escape"
              show={this.state.adding}
              onShow={() => this.setState({ adding: true })}
              onHide={() => this.setState({ adding: false })}
              >
              <Button bsStyle="primary">
                Add Escape
              </Button>

              <SimpleEscapeForm
                enterTeam
                values={{ roomId: this.props.roomId }}
                modal={true}
                errors={this.props.errors.escape}
                buttonText="Add"
                cancelText="Cancel"
                onSubmit={(e, values) => this.addEscape(e, values)}
                onCancel={() => this.setState({ adding: false })}
              />
            </OzModalButton>
          </div>
        </div>

        {this.renderEscapes()}
      </div>
    );
  }
}


class ProManageRoom extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['room', getRoom, p => p.id],
    ['schedules', listSchedules, p => { return [{ roomId: p.id }] }],
    ['escapes', listEscapes, p => { return [{ room: p.id }] }],
  ]

  state = {
    widgetColor: 'light',
    widgetSize: 10,
  };

  saveRoom(e, values) {
    console.log('save changes to room:', values);
    let room = this.props.room;
    this.props.updateRoom(room.id, values)
      .then(resp => {
        console.log('update room resp:', resp);
        if (resp.error) {
          return;
        }
        NotificationManager.success('Saved changes to ' + room.name);
        navTo('/pro/rooms/' + room.id);
      });
  }

  renderEdit() {
    let room = this.props.room;
    if (!room) return;

    return (
      <ProRoomForm
        errors={this.props.errors.room}
        values={room}
        onSubmit={(e, values) => this.saveRoom(e, values)}
        buttonText="Save Changes"
      />
    );
  }

  renderPricing() {
    let room = this.props.room;
    if (!room) return;
    if (!room.pricing) return;

    return (
      <Table>
        <tbody>
          {room.pricing.pricePerPerson && <tr>
            <th>Price per person</th>
            <td>{money(room.pricing.pricePerPerson, 'USD')}</td>
           </tr>}
          {room.pricing.pricePerPersonPrivate && <tr>
            <th>Price per person for private</th>
            <td>{money(room.pricing.pricePerPersonPrivate, 'USD')}</td>
           </tr>}
        </tbody>
      </Table>
    );
  }

  renderOverview() {
    let room = this.props.room;
    if (!room) return;

    return (
      <div className="overview">
        <Table>
          <tbody>
            <tr>
              <th>Name</th>
              <td>{room.name}</td>
            </tr>
            <tr>
              <th>Location</th>
              <td>{room.location.address}</td>
            </tr>
            <tr>
              <th>Description</th>
              <td>{room.description}</td>
            </tr>
            <tr>
              <th>Game length</th>
              <td>{room.minutes}</td>
            </tr>
            <tr>
              <th>Difficulty</th>
              <td>{room.difficulty}</td>
            </tr>
            <tr>
              <th>Min players</th>
              <td>{room.minPeople}</td>
            </tr>
            <tr>
              <th>Max players</th>
              <td>{room.maxPeople}</td>
            </tr>
            <tr>
              <th>Pricing</th>
              <td>{this.renderPricing()}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }

  refresh() {
    return this.props.listSchedules({ roomId: this.props.params.id }, { background: true });
  }

  refreshEscapes() {
    return new Promise((good, bad) => {
      this.setState(
        { forceRefresh: true },
        () => {
          this.setState(
            { forceRefresh: false },
            () => {
              this.props.listEscapes({ room: this.props.params.id }, { background: true })
                .then(() => good())
            }
          );
        }
      );
    });
  }

  addSchedule(e, values) {
    console.log('add schedule', values);
    this.props.createSchedule(values)
      .then(resp => {
        if (resp.error) return;
        this.refresh()
          .then(() => this.setState({ addingSchedule: false }));
      });
  }

  addWeeklySlot(e, values) {
    console.log('add weekly slot', values);
    this.props.createWeeklySlot(values)
      .then(resp => {
        console.log('create weekly slot resp', resp);
        if (resp.error) return;
        this.refresh()
          .then(() => this.setState({ addingSlot: false }));
      });
  }

  deleteWeeklySlot(weeklySlot) {
    let msg = ('Delete ' + weeklySlot.prettyDayOfWeek + ' ' +
               weeklySlot.prettyStart + '-' + weeklySlot.prettyEnd + '?\n\n' +
               'Existing bookings will NOT be deleted')
    if (!confirm(msg)) return;

    this.props.deleteWeeklySlot(weeklySlot.id)
      .then(() => {
        this.refresh();
      });
  }

  saveSchedule(e, scheduleId, values) {
    this.props.updateSchedule(scheduleId, values)
      .then(resp => {
        if (resp.error) return;
        this.refresh()
          .then(() => this.setState({ editingSchedule: false }));
      });
  }

  deleteSchedule(scheduleId) {
    let msg = ('Entire schedule and ALL associated booking times?\n\n' +
               'Existing bookings will NOT be deleted');
    if (!confirm(msg)) return;

    this.props.deleteSchedule(scheduleId)
      .then(this.refresh());
  }

  renderSchedule() {
    let room = this.props.room;
    let schedules = this.props.schedules;
    if (!room || !schedules) return;

    let nodes = schedules.items.map(schedule => {
      if (schedule.dead) return null;
      let scheduleId = schedule.id;

      let weeklySlots = schedule.weeklySlots;
      weeklySlots = weeklySlots.sort((a, b) => {
        if (a.dayOfWeek != b.dayOfWeek) return a.dayOfWeek - b.dayOfWeek;
        if (a.hour != b.hour) return a.hour - b.hour;
        return a.minute - b.minute;
      });

      let slotNodes = weeklySlots.map(weeklySlot => {
        return (
          <div key={weeklySlot.id} className="weekly-slot">
            <div className="day">{weeklySlot.prettyDayOfWeek}</div>
            <div className="time-range">{weeklySlot.prettyStart}-{weeklySlot.prettyEnd}</div>
            <div className="controls">
              <Button bsSize="sm" onClick={() => this.deleteWeeklySlot(weeklySlot)}><FontAwesome name="trash" /></Button>
            </div>
          </div>
        );
      });

      return (
        <div key={schedule.id} className="schedule">
          <div className="schedule-header">
            <div className="schedule-title">
              Schedule effective <b>{moment(schedule.effectiveFrom, 'YYYY-MM-DD').format('dddd MMM Do, YYYY')}</b>{' '}
              {schedule.active && <span className="active"><FontAwesome name="check" /> active</span>}
            </div>

            <div className="controls">
              <Button onClick={() => this.deleteSchedule(scheduleId)}><FontAwesome name="trash" /></Button>{' '}

              <OzModalButton
                modalTitle="Add Time Slot"
                show={this.state.editingSchedule == scheduleId}
                onShow={() => this.setState({ editingSchedule: scheduleId })}
                onHide={() => this.setState({ editingSchedule: false })}
              >
                <Button>Edit Schedule</Button>

                <ScheduleForm
                  modal={true}
                  values={schedule}
                  errors={this.props.errors.schedule}
                  onCancel={() => this.setState({ editingSchedule: false })}
                  onSubmit={(e, values) => this.saveSchedule(e, scheduleId, values)}
                  buttonText="Save Changes"
                  cancelText="Cancel"
                  edit
                />
              </OzModalButton>{' '}

              <OzModalButton
                modalTitle="Add Time Slot"
                show={this.state.addingSlot == scheduleId}
                onShow={() => this.setState({ addingSlot: scheduleId })}
                onHide={() => this.setState({ addingSlot: false })}
              >
                <Button bsStyle="primary">Add Time Slot</Button>

                <WeeklySlotForm
                  modal={true}
                  values={{ scheduleId }}
                  errors={this.props.errors.weeklySlot}
                  onCancel={() => this.setState({ addingSlot: false })}
                  onSubmit={(e, values) => this.addWeeklySlot(e, values)}
                  buttonText="Add Time Slot"
                  cancelText="Cancel"
                  room={room}
                />
              </OzModalButton>
            </div>
          </div>

          <div className="weekly-slots">
            {slotNodes}
            {slotNodes.length == 0 && <div className="no-slots">No times slots yet...</div>}
          </div>
        </div>
      );
    });

    return (
      <div className="schedules">
        <div className="schedules-header">
          <div className="schedules-title">
            Schedules for {room.name}
          </div>

          <div className="controls">
            <OzModalButton
              modalTitle="Add Schedule"
              show={this.state.addingSchedule}
              onShow={() => this.setState({ addingSchedule: true })}
              onHide={() => this.setState({ addingSchedule: false })}
            >
              <Button>Add Schedule</Button>

              <ScheduleForm
                modal={true}
                values={{ roomId: room.id }}
                errors={this.props.errors.schedule}
                onCancel={() => this.setState({ addingSchedule: false })}
                onSubmit={(e, values) => this.addSchedule(e, values)}
                buttonText="Add Schedule"
                cancelText="Cancel"
              />
            </OzModalButton>
          </div>
        </div>

        <div className="schedules">
          {nodes}
        </div>
      </div>
    );
  }

  renderBookings() {
    return <ProBookableSlots roomId={this.props.params.id} />;
  }

  forceRefresh() {
    this.setState({ forceRefresh: true },
                  () => this.setState({ forceRefresh: false }));
  }

  renderLeaderboard() {
    let room = this.props.room;
    let escapes = this.props.escapes;
    if (!room || !escapes) return;

    let params = {
      color: this.state.widgetColor,
      size: this.state.widgetSize,
    };

    let iframeUrl = 'https://www.escapespy.com/leaderboard/' + room.id + '?' + qs.stringify(params);
    let height = params.size * 36 + 40;

    let hasEscapes = escapes.items.length > 0;
    let sizeOptions = [];
    for (let i = 1; i <= 20; i++) { sizeOptions.push(i) }

    let previewNode = (
      <div className="widget-preview">
        <div className="widget-header">Preview</div>
        <div className="explanation">
          Below is a preview leaderboard widget as it will display on your site.
        </div>
        <div className="customize">
          <div className="customize-option">
            <div>Color scheme:</div>
            <OzPills value={this.state.widgetColor}>
              <div key="light" onClick={() => this.setState({ widgetColor: 'light' })}>Light</div>
              <div key="dark" onClick={() => this.setState({ widgetColor: 'dark' })}>Dark</div>
            </OzPills>
          </div>

          <div className="customize-option">
            <div>Number to show:</div>
            <FormControl
              componentClass="select"
              value={this.state.widgetSize}
              onChange={e => { this.setState({ widgetSize: e.target.value }); this.forceRefresh() }}
              >
              {sizeOptions.map(o => <option key={o} value={o}>{o}</option>)}
            </FormControl>
          </div>
          
        </div>
        <div className={cx('site-padding', this.state.widgetColor)}>
          <LeaderboardWidget
            key={room.id}
            roomId={room.id}
            {...params}
          />
        </div>
      </div>
    );
    let codeNode = (
      <div className="widget-code">
        <div className="widget-header">Add to your site</div>
        Add the following code to your site to display the leaderboard:

        <div className="code">
          &lt;div style="max-width:300px;width:100%;margin:0 auto"&gt;&lt;iframe scrolling="no" style="border:0;width:100%;height:{height}px" src="{iframeUrl}"&gt;&lt;/iframe&gt;&lt;a href="https://www.escapespy.com" style="font-size:11px;color:#888;opacity:.8;font-family:sans-serif;"&gt;Leaderboard powered by EscapeSpy&lt;/a&gt;&lt;/div&gt;
        </div>
      </div>
    );

    return (
      <div>
        <div className="widget">
          <div className="display">
            <div className="edit">
              {/*<div className="widget-header">Manage Leaderboard</div>*/}
              <EditLeaderboard
                listEscapes={this.props.listEscapes}
                updateEscape={this.props.updateEscape}
                addEscape={this.props.addEscape}
                onAdd={() => this.refreshEscapes()}
                errors={this.props.errors}
                key={room.id}
                room={room}
                roomId={room.id}
              />
            </div>
            
            {hasEscapes && !this.state.forceRefresh && previewNode}
            {hasEscapes && codeNode}

          </div>
        </div>
      </div>
    );
  }

  render() {
    let roomName = '';
    let locationName = ''
    if (this.props.room) {
      roomName = this.props.room.name;
      locationName = this.props.room.location.address;
    }

    return (
      <Wrapper className="ProManageRoom" padded pro>
        <Helmet>
          Manage Room - EscapeSpy
        </Helmet>

        <div className="pro-header">
          {roomName}
          <div className="pro-sub-header">{locationName}</div>
        </div>

        <OzTabs>
          <div tabKey="overview" tabName="Overview">
            {this.renderOverview()}
          </div>
          {/*
          <div tabKey="bookings" tabName="Bookings">
            {this.renderBookings()}
          </div>
          */}
          <div tabKey="edit" tabName="Edit Room">
            {this.renderEdit()}
          </div>
          {/*
          <div tabKey="schedule" tabName="Schedule">
            {this.renderSchedule()}
          </div>
            */}
          <div tabKey="leaderboard" tabName="Leaderboard">
            {this.renderLeaderboard()}
          </div>
        </OzTabs>

      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    room: state.get.room,
    schedules: state.list.schedule,
    escapes: state.list.escape,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    updateRoom,
    createSchedule,
    updateSchedule,
    listSchedules,
    deleteSchedule,
    createWeeklySlot,
    deleteWeeklySlot,
    listEscapes,
    updateEscape,
    addEscape,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProManageRoom);



/** WEBPACK FOOTER **
 ** ./src/components/ProManageRoom.js
 **/